import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login");
      return;
    }
    (async () => {
      try {
        const ref = (() => { try { return sessionStorage.getItem("hc_ref") || undefined; } catch (e) { return undefined; } })();
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, ...(ref ? { ref } : {}) });
        try { sessionStorage.removeItem("hc_ref"); } catch (e) {}
        setUser(data.user);
        if (data.user?.referral_premium_until && data.user?.subscription_tier === "paid") {
          // Best-effort welcome toast (sonner may not render between page swaps, but harmless)
        }
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { state: { user: data.user } });
      } catch (e) {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FCFAF8]">
      <p className="text-[#7A736E]" data-testid="auth-callback-loading">Welcoming you in…</p>
    </div>
  );
}
